import { Grid } from '@mui/material'
import Programa from '../../components/Programa/Programa'
import PrimeTable from '../../components/PrimeTable'
import { LuBookOpenCheck, LuMicroscope, LuStethoscope } from 'react-icons/lu'
import IconeEspecialista from './IconeEspecialista'
import {
  FaAppleAlt,
  FaBrain,
  FaNotesMedical,
  FaTemperatureHigh,
} from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { useCallback, useContext, useState } from 'react'
import { metodoPrograma } from '../../components/api'
import { GlobalContext } from '../../App'
import WeekNavigator from './componente/WeekNavigator'
import dayjs from 'dayjs'
import { MdAccessibility } from 'react-icons/md'
import IconeQuestionario from './IconeQuestionario'
import IconeQuestionarioTermo from './IconeQuestionarioTermo'
import ModalVisualizaQuestionario from './ModalVisualizaQuestionario'

const Atendimento = () => {
  const { dispatch, localAtendimento } = useContext(GlobalContext)
  const [dataInicial, setDataInicial] = useState(undefined)
  const [dataFinal, setDataFinal] = useState(undefined)
  const [refresh, setRefresh] = useState(0)
  const [openModalQuestionario, setOpenModalQuestionario] = useState(false)
  const [questionarioSelecionado, setQuestionarioSelecionado] = useState({})

  const history = useNavigate()

  const buscaDadosMedico = useCallback(
    async (idAgenda) => {
      try {
        let cdMedico = ''

        const agendaRes = await metodoPrograma(
          'getAgenda',
          { idAgenda, idLocalAtendimento: localAtendimento[0] },
          'CtrlAtendimento',
        )

        if (agendaRes?.status) {
          const agenda = agendaRes?.lista?.[0]

          dispatch({ type: 'setAgenda', value: agenda })

          cdMedico = agenda?.[2]
        }

        // Só chama se tiver cdMedico válido
        if (cdMedico) {
          const medicoRes = await metodoPrograma(
            'buscaDadosMedico',
            { cdMedico },
            'CtrlAtendimento',
          )

          if (medicoRes?.status) {
            dispatch({ field: 'medico', value: medicoRes })
            history('/programas/consultorio/agenda')
          }
        }
      } catch (error) {
        console.error('Erro ao buscar dados do médico:', error)
      }
    },
    [dispatch, localAtendimento, history],
  )

  const visualizaRespostaQuestionario = useCallback(async (idResposta) => {
    if (Number.isInteger(idResposta)) {
      const res = await metodoPrograma(
        'getResposta',
        { idResposta },
        'CtrlAtendimento',
      )
      if (res.status) {
        setQuestionarioSelecionado({
          questionario: { idQuestionario: res.idQuestionario },
          resposta: { idResposta },
        })
        setOpenModalQuestionario(true)
      }
    }
  }, [])
  const selecionaProfissional = (codigo) => {
    /*
      21	1	1	"Avaliação Médica"
      22	1	2	"Avaliação Nutricional Mônica"
      53	1	2	"Avaliação Nutricional Marlowa"
      23	1	3	"Avaliação Psicológica Ingrid"
      52	1	8	"Avaliação Psicológica Rosana"
      50	1	4	"Avaliação Biológica"
      */

    if (codigo === 'nutriMonica') {
      // dispatch({ type: 'setAgenda', value: 22 })
      buscaDadosMedico(22)
    } else if (codigo === 'nutriMarlowa') {
      // dispatch({ type: 'setAgenda', value: 53 })
      buscaDadosMedico(53)
    } else if (codigo === 'bioTatiana') {
      // dispatch({ type: 'setAgenda', value: 50 })
      buscaDadosMedico(50)
    } else if (codigo === 'bioTaiana') {
      // dispatch({ type: 'setAgenda', value: 56 })
      buscaDadosMedico(56)
    } else if (codigo === 'psicoIngrid') {
      // dispatch({ type: 'setAgenda', value: 23 })
      buscaDadosMedico(23)
    } else if (codigo === 'psicoRosana') {
      // dispatch({ type: 'setAgenda', value: 52 })
      buscaDadosMedico(52)
    } else if (codigo === 'clinico') {
      // dispatch({ type: 'setAgenda', value: 21 })
      buscaDadosMedico(21)
    } else if (codigo === 'termo') {
      // dispatch({ type: 'setAgenda', value: 21 })
      buscaDadosMedico(51)
    }
  }

  return (
    <Programa codigo="CtrlAtendimento" habTrocaLocal={true}>
      <Grid container spacing={2}>
        <ModalVisualizaQuestionario
          data={questionarioSelecionado}
          openModalQuestionario={openModalQuestionario}
          setRefresh={setRefresh}
          setOpenModalQuestionario={setOpenModalQuestionario}
        />
        <Grid item xs={12}>
          <WeekNavigator
            onChange={({ start, end }) => {
              setDataInicial(start)
              setDataFinal(end)
              setRefresh((prev) => prev + 1)
            }}
          />
        </Grid>

        <Grid item xs={12}>
          {dataInicial !== undefined && dataFinal !== undefined && (
            <PrimeTable
              codigo="CtrlAtendimento"
              parametros={{
                dataInicial: dataInicial
                  ? dayjs(dataInicial).format('YYYY-MM-DD HH:mm:ss')
                  : undefined,
                dataFinal: dataFinal
                  ? dayjs(dataFinal).format('YYYY-MM-DD HH:mm:ss')
                  : undefined,
              }}
              refresh={refresh}
              action="lista"
              habSearch
              rows={10}
              head={[
                'Proposta',
                'Paciente',
                'Termos e Questionários',
                'Agendamento',
              ]}
              colStyle={[
                { width: '5%' },
                { width: '40%' },
                { width: '20%' },
                { width: '25%' },
              ]}
              line={(item) => [item[0], item?.[3]?.nmPaciente || '']}
              collumnsDateHour={[3]}
              columnOptions={[
                {
                  alias: 2,
                  customJsx: ({ linhaOriginal }) => (
                    <Grid container spacing={2}>
                      <Grid item>
                        <IconeQuestionario
                          icon={LuBookOpenCheck}
                          titulo="Termos"
                          status={linhaOriginal?.[26]}
                          onClick={() =>
                            visualizaRespostaQuestionario(linhaOriginal?.[26])
                          }
                        />
                      </Grid>
                      <Grid item>
                        <IconeQuestionario
                          icon={FaNotesMedical}
                          titulo="Anamnese"
                          status={linhaOriginal?.[27]}
                          disabilitado={linhaOriginal?.[27] === null}
                          onClick={() =>
                            visualizaRespostaQuestionario(linhaOriginal?.[27])
                          }
                        />
                      </Grid>
                      <Grid item>
                        <IconeQuestionario
                          icon={FaBrain}
                          titulo="Psicológica"
                          status={linhaOriginal?.[28]}
                          disabilitado={linhaOriginal?.[28] === null}
                          onClick={() => {
                            visualizaRespostaQuestionario(linhaOriginal?.[28])
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <IconeQuestionarioTermo
                          icon={MdAccessibility}
                          titulo="Termografia"
                          status={linhaOriginal?.[30]}
                          codigo={linhaOriginal?.[29]}
                          onClick={() => {
                            visualizaRespostaQuestionario(linhaOriginal?.[29])
                          }}
                        />
                      </Grid>
                    </Grid>
                  ),
                },
                {
                  alias: 3,
                  customJsx: ({ linhaOriginal }) => (
                    <Grid container spacing={2}>
                      <Grid item>
                        <IconeEspecialista
                          icon={LuMicroscope}
                          titulo="Biólogo"
                          status={linhaOriginal[21]}
                          onClick={() => selecionaProfissional('bio')}
                          agendas={[
                            {
                              id: 50,
                              nome: 'Avaliação Biológica (Tatiana)',
                              onClick: () =>
                                selecionaProfissional('bioTatiana'),
                            },
                            {
                              id: 56,
                              nome: 'Avaliação Biológica (Taiana)',
                              onClick: () => selecionaProfissional('bioTaiana'),
                            },
                          ]}
                        />
                      </Grid>

                      <Grid item>
                        <IconeEspecialista
                          icon={FaAppleAlt}
                          titulo="Nutricionista"
                          status={linhaOriginal[22]}
                          agendas={[
                            {
                              id: 22,
                              nome: 'Avaliação Nutricional (Mônica)',
                              onClick: () =>
                                selecionaProfissional('nutriMonica'),
                            },
                            {
                              id: 53,
                              nome: 'Avaliação Nutricional (Marlowa)',
                              onClick: () =>
                                selecionaProfissional('nutriMarlowa'),
                            },
                          ]}
                        />
                      </Grid>

                      <Grid item>
                        <IconeEspecialista
                          icon={FaBrain}
                          titulo="Psicólogo"
                          status={linhaOriginal[23]}
                          agendas={[
                            {
                              id: 23,
                              nome: 'Avaliação Psicológica (Ingrid)',
                              onClick: () =>
                                selecionaProfissional('psicoIngrid'),
                            },
                            {
                              id: 52,
                              nome: 'Avaliação Psicológica (Rosana)',
                              onClick: () =>
                                selecionaProfissional('psicoRosana'),
                            },
                          ]}
                        />
                      </Grid>
                      <Grid item>
                        <IconeEspecialista
                          icon={FaTemperatureHigh}
                          titulo="Termografia"
                          status={linhaOriginal[25]}
                          onClick={() => selecionaProfissional('termo')}
                        />
                      </Grid>
                      <Grid item>
                        <IconeEspecialista
                          icon={LuStethoscope}
                          titulo="Clínico"
                          status={linhaOriginal[24]}
                          onClick={() => selecionaProfissional('clinico')}
                        />
                      </Grid>
                    </Grid>
                  ),
                },
              ]}
            />
          )}
        </Grid>
      </Grid>
    </Programa>
  )
}

export default Atendimento
